<template>
  <Card>
    <h1 slot="Title">Fund Center (Cont.)</h1>
    <div slot="MainContent">
      <p>
        This example shows the composition of a funds center hierarchy from HQDA at Level 1 to an FORSCOM Level 4 funds center at 3rd ID:
      </p>
      <div class="ThreeWrapper">
        <ul>
          <li class="OneThird">
            <b>Fund Center Position</b>
          </li>
          <li class="OneThird">
            <b>Represents</b>
          </li>
          <li class="OneThird">
            <b>Example</b>
          </li>
        </ul>
        <ul>
          <li class="OneThird">
            1
          </li>
          <li class="OneThird">
            Appropriation Sponsor
          </li>
          <li class="OneThird">
            A (Army)
          </li>
        </ul>
        <ul>
          <li class="OneThird">
            2-3
          </li>
          <li class="OneThird">
            Operating Agency
          </li>
          <li class="OneThird">
            76 (FORSCOM)
          </li>
        </ul>
        <ul>
          <li class="OneThird">
            4-5
          </li>
          <li class="OneThird">
            Level 3 and 4
          </li>
          <li class="OneThird">
            VV (Region/ 3 ID)
          </li>
        </ul>
      </div>
      <div slot="MainContent">
        <div class="ThreeWrapper">
          <ul>
            <li class="OneThird">
              <b>Other Examples of Fund Centers:</b>
            </li>
          </ul>
          <ul>
            <li class="OneThird">
              A2ABM
            </li>
            <li class="OneThird">
              Fort Jackson
            </li>
            <li class="OneThird">
              A57HB CASCOM
            </li>
          </ul>
          <ul>
            <li class="OneThird">
              A76NN
            </li>
            <li class="OneThird">
              82 Airborne
            </li>
            <li class="OneThird">
              A76YY HQ FORSCOM
            </li>
          </ul>
        </div>
      </div>
      <p>
        202011D20 <b><u>A76VV</u></b> 131096QLOG 6100.2617 WBS, Internal Order or Cost Center 1000000067 021001
      </p>
    </div>
    <div slot="Notes">
      <p><span style="color: #ffffff;"><strong>Fund Center (Cont.)</strong></span></p>
      <p><span style="color: #ffffff;"><strong>&nbsp;</strong></span></p>
      <p><span style="color: #ffffff;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (2) <strong>Positions 1 - 5:</strong> Funds Center record contains information about specific organizational elements within the Army that are authorized to receive, distribute, and manage funds.</span></p>
      <p><span style="color: #ffffff;">&nbsp;</span></p>
      <p><span style="color: #ffffff;">&nbsp;&nbsp;&nbsp;&nbsp; Funds Center: A76VV</span></p>
      <p><span style="color: #ffffff;">&nbsp;</span></p>
      <p><span style="color: #ffffff;">&nbsp;&nbsp;&nbsp;&nbsp; <u>Position</u>&nbsp; <u>Represents</u>&nbsp; &nbsp;&nbsp; &nbsp; <u>Example</u></span></p>
      <p><span style="color: #ffffff;">&nbsp;</span></p>
      <p><span style="color: #ffffff;">&nbsp;&nbsp;&nbsp;&nbsp; 1&nbsp; Appropriation Sponsor&nbsp; A (Army)</span></p>
      <p><span style="color: #ffffff;">&nbsp;&nbsp;&nbsp;&nbsp; 2-3&nbsp; Operating Agency&nbsp; 76 (FORSCOM)</span></p>
      <p><span style="color: #ffffff;">&nbsp;&nbsp;&nbsp;&nbsp; 4-5&nbsp; Level 3 and 4*&nbsp; VV (Region/Organization) Fort Stewart</span></p>
      <p><span style="color: #ffffff;"><strong>Other Examples of Fund Centers:</strong></span></p>
      <p><span style="color: #ffffff;">A2ABM&nbsp; Fort Jackson&nbsp; A57HB CASCOM</span></p>
      <p><span style="color: #ffffff;">A76NN&nbsp; 82 Airborne&nbsp; A76YY&nbsp; HQ FORSCOM&nbsp;</span></p>
      <p><span style="color: #ffffff;">&nbsp;</span></p>
      <p><span style="color: #ffffff;">*Funding levels: 1- D.A., 2- MACOM- 3- Installation of Activity Level 4- Subordinate unit or activity.</span></p>
      <p><span style="color: #ffffff;"><strong>Note: Army organizations can choose the level of their Funds Center structure (level 3 or level 4 only). </strong></span></p>
    </div>
  </Card>
</template>

<style scoped>
.ThreeWrapper {
  width: 100%;
  margin-bottom: 32px;
}

ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding-left: 0;
}

ul > li {
  width: 33%;
  list-style: none;
  margin-bottom: 0;
}

ul > li > b {
  font-weight: 700;
}

</style>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'StatesofanAppropriationExamples',
  
  data() {
    return {
    }
  }
  
}
</script>